<template>
  <div>
    <el-alert v-if="authError" type="error" :title="authError" show-icon @close="closeAlert()"></el-alert>

    <template v-if="user">
      <p class="mv3 f6 lh-copy mid-gray">Please enter and confirm a new password to recover access and sign in.</p>

      <el-form :model="user" :rules="rules" ref="form" @submit.native.prevent="submit()">
        <el-form-item label="Name">
          <el-input type="text" v-model="user.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="Password" prop="password">
          <el-input type="password" v-model="user.password"></el-input>
        </el-form-item>
        <el-form-item label="Confirm password" prop="password_confirmation">
          <el-input type="password" v-model="user.password_confirmation"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" native-type="submit">Reset password</el-button>
        </el-form-item>
      </el-form>
    </template>

    <template v-if="!user">
      <p class="mv3 mb3 f6 lh-copy mid-gray">Please begin the process again and follow the link in the email that is sent to you.</p>
      <el-button type="primary" @click="setError(null); $router.push({ name: 'reset_password' })">Reset password</el-button>
    </template>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      token: this.$route.query.token,
      rules: {
        password: [
          { required: true, min: 8, max: 72, trigger: 'blur' }
        ],
        password_confirmation: [
          { required: true, trigger: 'blur', message: 'confirmation is required' },
          { validator: this.passwordConfValidator, trigger: 'blur' }
        ]
      }
    }
  },

  created() {
    this.fetchPasswordReset(this.token)
      .catch(e => false);
  },

  computed: {
    ...mapState('auth', ['user', 'authError'])
  },

  methods: {
    ...mapActions('auth', ['fetchPasswordReset', 'resetPassword']),
    ...mapMutations('auth', ['setError']),

    passwordConfValidator(rule, value, callback) {
      if (value !== this.user.password) {
        callback(new Error('password must match'))
      } else {
        callback()
      }
    },

    submit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const user = _.pickBy(this.user, (v,k) => _.includes(['password', 'password_confirmation'], k))
          this.resetPassword({ token: this.token, user })
            .then(() => window.location.assign('/app'))
            .catch(() => false)
        } else {
          return false;
        }
      })
    },

    closeAlert() {
      this.setError(null)
    }
  }
}
</script>